import { createApp } from 'vue'
import {
  // Komponen yang sudah ada
  Radio,
  Spin,
  Col,
  Row,
  Popconfirm,
  Form,
  Divider,
  Button,
  Layout,
  Drawer,
  Menu,
  Avatar,
  Dropdown,
  Input,
  Popover,
  Upload,
  Pagination,
  Select,
  Checkbox,
  Modal,
  Tag,
  Table,
  AutoComplete,
  Card,
  DatePicker,
  Tabs,
  PageHeader,
  Descriptions,
  InputNumber,
  Space,
  Result,
  Tooltip,
} from 'ant-design-vue'
import PerfectScrollbar from 'vue3-perfect-scrollbar'

import App from './App.vue'
import router from './router'
import store from './store'
import './mixins.scss'

const app = createApp(App)

app
  .use(store)
  .use(router)
  // ... .use() untuk komponen yang sudah ada
  .use(Radio)
  .use(DatePicker)
  .use(Col)
  .use(Spin)
  .use(Row)
  .use(AutoComplete)
  .use(Pagination)
  .use(Popconfirm)
  .use(Form)
  .use(Divider)
  .use(Button)
  .use(Layout)
  .use(Drawer)
  .use(Menu)
  .use(Avatar)
  .use(Dropdown)
  .use(Input)
  .use(Popover)
  .use(Upload)
  .use(Select)
  .use(Checkbox)
  .use(Modal)
  .use(Tag)
  .use(Table)
  .use(Tabs)
  .use(Result)
  .use(Card)
  .use(PageHeader)
  .use(Descriptions)
  .use(InputNumber)
  .use(Space)
  .use(Tooltip)

  .use(PerfectScrollbar)
  .mount('#app')
